<template>
  <div class="top-right-btn" :style="style">
    <el-row>
      <!-- 高级搜索 -->
      <el-tooltip
        class="item"
        effect="dark"
        content="高级搜索"
        placement="top"
        v-if="showAdvancedSearchIcon"
      >
        <el-button circle @click="toggleAdvancedSearch()">
          <svg-icon icon-class="seearch-advanced" />
        </el-button>
      </el-tooltip>
      <!-- 显示隐藏搜索 -->
      <el-tooltip
        class="item"
        effect="dark"
        :content="showSearch ? '隐藏搜索' : '显示搜索'"
        placement="top"
        v-if="showSearchIcon"
      >
        <el-button circle icon="Search" @click="toggleSearch()" />
      </el-tooltip>
      <!-- 下载 -->
      <el-tooltip
        class="item"
        effect="dark"
        content="下载"
        placement="top"
        v-if="showDownloadIcon"
      >
        <el-button circle icon="Download" @click="toggleDownload()" />
      </el-tooltip>
      <!-- 刷新 -->
      <el-tooltip
        v-if="showRefresh"
        class="item"
        effect="dark"
        content="刷新"
        placement="top"
      >
        <el-button circle icon="Refresh" @click="refresh()" />
      </el-tooltip>
      <!-- 显示隐藏列 -->
      <SelectColumns
        v-show="tableName ? true : false"
        ref="selectColumnsRef"
        style="padding-left: 12px"
        :allVals="columns"
        :tableName="tableName"
        @updateTableCol="handleUpdateTableCol"
      />
    </el-row>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import SelectColumns from "../SelectColumns";
import { tryOnMounted } from "@vueuse/core";
const props = defineProps({
  /* 是否显示检索条件 */
  showSearch: {
    type: Boolean,
    default: false,
  },
  /* 是否显示检索图标 */
  showSearchIcon: {
    type: Boolean,
    default: true,
  },
  showAdvancedSearchIcon: {
    // 是否显示高级搜素图标
    type: Boolean,
    default: true,
  },
  /*是否显示高级搜索 */
  showAdvancedSearch: {
    type: Boolean,
    default: false,
  },
  /** 是否显示刷新按钮 */
  showRefresh: {
    type: Boolean,
    default: true,
  },
  /* 显隐列信息 */
  columns: {
    type: Array,
    default: () => [],
  },
  /* 显隐列类型（transfer穿梭框、checkbox复选框） */
  showColumnsType: {
    type: String,
    default: "checkbox",
  },
  /* 是否显示下载图标 */
  showDownloadIcon: {
    type: Boolean,
    default: true,
  },
  /* 是否显示下载 */
  showDownload: {
    type: Boolean,
    default: false,
  },
  /* 右外边距 */
  gutter: {
    type: Number,
    default: 10,
  },
  tableName: {
    // 表格的名字
    required: false,
    type: String,
    default: "",
  },
});

const emits = defineEmits([
  "update:showSearch",
  "update:showAdvancedSearch",
  "update:showDownload",
  "queryTable",
  "updateTableCol",
]);

const selectColumnsRef = ref(null);

const style = computed(() => {
  const ret = {};
  if (props.gutter) {
    ret.marginRight = `${props.gutter / 2}px`;
  }
  return ret;
});

// 搜索
function toggleSearch() {
  emits("update:showSearch", !props.showSearch);
}

// 高级搜索
function toggleAdvancedSearch() {
  emits("update:showAdvancedSearch", !props.showAdvancedSearch);
}

// 下载
function toggleDownload() {
  emits("update:showDownload", !props.showDownload);
}

// 刷新
function refresh() {
  emits("queryTable");
}

// 调整列
const handleUpdateTableCol = (cols) => {
  emits("updateTableCol", cols);
};

defineExpose({
  saveCol: (parms) => {
    selectColumnsRef.value.save(parms);
  },
  updateColOrder: (parms) => {
    selectColumnsRef.value.updateColOrder(parms);
  },
});
</script>

<style lang="scss" scoped>
:deep(.el-transfer__button) {
  border-radius: 50%;
  display: block;
  margin-left: 0px;
}
:deep(.el-transfer__button:first-child) {
  margin-bottom: 10px;
}
:deep(.el-dropdown-menu__item) {
  line-height: 30px;
  padding: 0 17px;
}
</style>
